import { call } from 'redux-saga/effects';
import { parseQueryString } from '../../../../utils/helperFunctions';
import notify from '../../../helpers/notify';
import request from '../../../helpers/request';
import { SHOW_CONTENTS_INDICATORS } from '../constants';

const getContentsIndicatorNotifier = (params, loader = false) =>
  notify({
    type: SHOW_CONTENTS_INDICATORS,
    params,
    loader,
  });

function* getContentsIndicatorAction({ params }) {
  const strQueryParams = parseQueryString(params);
  yield call(request, {
    type: SHOW_CONTENTS_INDICATORS,
    method: 'get',
    endpoint: `/indicators/getContents${strQueryParams}`,
  });
}

export { getContentsIndicatorAction, getContentsIndicatorNotifier };
